import axios from "axios";
import { setTimeout } from "timers";
import { Decimal } from "decimal.js";

var commonMixin = {
  data() {
    return {
      //用户权限: 是否可设置智配AI机器人 兼容 1 or true 的设置
      CanSetupZhipeiRobot:
        localStorage.getItem("CanSetupZhipeiRobot") == "true" || localStorage.getItem("CanSetupZhipeiRobot") == "1"
    };
  },

  methods: {
    //特殊字符判断
    checkSpecialKey(str) {
      var specialKey = "[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥¥……&*（）——|{}【】‘；：”“'。，、？]‘'";
      for (var i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false;
        }
      }
      return true;
    },
    //存储cookie
    setCookie(name, value, days) {
      var _this = this;
      var Days = days;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      if (days == 0) {
        document.cookie = name + "=" + escape(value);
      } else {
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
      }
    },
    //得到cookie
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    //获取url参数
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      } else {
        var strHash = window.location.hash;

        if (strHash && strHash.length > 0 && strHash.indexOf("?") > -1) {
          r = strHash.substr(strHash.indexOf("?") + 1).match(reg);
        }
        if (r != null) {
          return unescape(r[2]);
        }
      }
      return null;
    },
    // 新版函数 支持解析中文
    // 取得url query 兼容vue格式url的锚点后的参数
    getQueryString_cn(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      } else {
        var strHash = window.location.hash;

        if (strHash && strHash.length > 0 && strHash.indexOf("?") > -1) {
          r = strHash.substr(strHash.indexOf("?") + 1).match(reg);
        }
        if (r != null) {
          return decodeURIComponent(r[2]);
        }
      }
      return null;
    },
    //更新url参数
    updateQueryStringParameter(uri, key, value) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = uri.indexOf("?") !== -1 ? "&" : "?";
      if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
      } else {
        return uri + separator + key + "=" + value;
      }
    },
    //用axios进行数据交互
    axios(opt) {
      this.$http = axios;
      var _this = this;
      var opts = {};
      opts.method = opt.method.toUpperCase() || "POST";
      opts.url = opt.url || "";
      opts.data = opt.data || null;
      opts.dataType = "JSON";
      var _SourceType = 5; //PC端

      var _UserTicket = "";
      // var _key = "123456789";
      var _signCode = "789649779a49df79sad7fa9sd87";
      var _time = Math.round(new Date().getTime() / 1000).toString();
      var xmlHttp = null;
      var _dataOpts = {
        Header: {
          SourceType: _SourceType,
          UserTicket: _UserTicket,
          SignCode: _signCode,
          // "machineKey": _key,
          timeStamp: _time
          // "version": 4.0,
        },
        Body: opts.data
      };
      opts.data = _dataOpts;
      this.$http(opts).then(opt.success);
    },
    ajax(opt) {
      var _this = this;
      //支付宝环境 or 微信环境 or 非APP环境, 则执行Jquery的Ajax
      opt = opt || {};
      opt.method = opt.method.toUpperCase() || "POST";

      opt.url = opt.url || "";
      opt.async = opt.async;
      opt.data = opt.data || null;
      opt.success = opt.success || function() {};
      opt.beforeSend =
        opt.beforeSend ||
        function() {
          // _this.$loading.show('加载中...')
        };
      opt.complete =
        opt.complete ||
        function() {
          setTimeout(function() {
            // _this.$loading.hide()
          }, 300);
        };
      var _SourceType = 5; //PC端
      var _Success = opt.success;
      //注意, 开发者调试模式时, 开发者必须在cookie里设置开关声明, 别改硬编码!
      var _UserTicket = this.getCookie("CJML.CPP.UserTicket") || ""; //从cookie里读取用户票据
      // var _key = "";
      var _signCode = "789649779a49df79sad7fa9sd87";
      var _time = Math.round(new Date().getTime() / 1000).toString();
      var xmlHttp = null;
      var _dataOpts = opt.data;

      opt.success = function(rep) {
        if (rep.status != 0) {
          _this.$message.warning(rep.message);
          _this.$loading.hide();
        } else {
          _Success(rep);
        }
      };
      opt.data = _dataOpts;
      return $.ajax(opt);
    },
    //指定仓库是否店员所属仓库 (目标是云店仓库)
    isStaffWarehouse(warehouseId) {
      var setting = localStorage.getItem("StaffWarehouse") || "";
      return setting.indexOf("|" + warehouseId + "|") >= 0;
    },
    //指定仓库是否店员所属仓库 (目标是WMS仓库)
    isStaffWarehouse_WMS(warehouseId) {
      var setting = localStorage.getItem("StaffWarehouse_WMS") || "";
      return setting.indexOf("|" + warehouseId + "|") >= 0;
    },
    //无loading请求，适用于特殊情况
    request(opt) {
      var _this = this;
      opt = opt || {};
      opt.method = opt.method.toUpperCase() || "POST";

      opt.url = opt.url || "";
      opt.async = opt.async;
      opt.data = opt.data || null;
      opt.success = opt.success || function() {};
      opt.beforeSend =
        opt.beforeSend ||
        function() {
          // _this.$loading.show('加载中...')
        };
      opt.complete =
        opt.complete ||
        function() {
          setTimeout(function() {
            // _this.$loading.hide()
          }, 300);
        };
      var _SourceType = 5; //PC端
      var _Success = opt.success;
      //注意, 开发者调试模式时, 开发者必须在cookie里设置开关声明, 别改硬编码!
      var _UserTicket = this.getCookie("CJML.CPP.UserTicket") || ""; //从cookie里读取用户票据
      // var _key = "";
      var _signCode = "789649779a49df79sad7fa9sd87";
      var _time = Math.round(new Date().getTime() / 1000).toString();
      var xmlHttp = null;
      var _dataOpts = opt.data;

      opt.success = function(rep) {
        if (rep.status != 0) {
          _this.$message.warning(rep.message);
          _this.$loading.hide();
        } else {
          _Success(rep);
        }
      };
      opt.data = _dataOpts;
      return $.ajax(opt);
    },

    //引入decimal.js的相减
    //解决浮点数的计算问题
    decimal_sub(a, b) {
      return new Decimal(Number(a)).sub(new Decimal(Number(b))).toNumber();
    },

    //引入decimal.js的相加
    //解决浮点数的计算问题
    decimal_add(a, b) {
      return new Decimal(Number(a)).add(new Decimal(Number(b))).toNumber();
    },

    //引入decimal.js的相乘
    //解决浮点数的计算问题
    decimal_mul(a, b) {
      return new Decimal(Number(a)).mul(new Decimal(Number(b))).toNumber();
    }
  }
};
export { commonMixin };
